export const genTextElement = (
  id: number,
  text: string,
  start: number,
  end: number,
  width: number,
  height: number,
  x: number,
  y: number,
  audioLength?: number,
  audioPath?: string
) => {
  const duration = (end - start) * 1000; // in miliseconds

  return {
    type: "text",
    name: text,
    opacity: 1,
    visible: true,
    selectable: true,
    removable: true,
    alwaysOnTop: false,
    showInExport: true,
    x,
    y,
    width,
    height,
    rotation: 0,
    animations: [],
    blurEnabled: false,
    blurRadius: 10,
    brightnessEnabled: false,
    brightness: 0,
    sepiaEnabled: false,
    grayscaleEnabled: false,
    shadowEnabled: false,
    shadowBlur: 5,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowColor: "black",
    shadowOpacity: 1,
    draggable: true,
    resizable: true,
    contentEditable: true,
    styleEditable: true,
    text: text,
    placeholder: "",
    fontSize: 30,
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "normal",
    textDecoration: "",
    fill: "white",
    align: "center",
    verticalAlign: "top",
    strokeWidth: 0,
    stroke: "black",
    lineHeight: 1.2,
    letterSpacing: 0,
    backgroundEnabled: false,
    backgroundColor: "transparent",
    backgroundOpacity: 1,
    backgroundCornerRadius: 0.5,
    backgroundPadding: 0.5,
    custom: {
      startAt: start * 1000,
      duration: duration,
      endAt: end * 1000,
      type: "transcript",
      start,
      end,
      id,
      audioLength,
      audioPath,
      isTranscriptModified: false,
    },
  };
};
